import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, SearchDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import SearchTemplate from '@components/templates/SearchTemplate/SearchTemplate'
import { search } from '@utils/elasticsearch'

const Search = ({ pagina, query, risultati }) => {
  return <SearchTemplate pagina={pagina} query={query} risultati={risultati} />
}

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ res, query, locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'search', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const q = (typeof query?.q == 'string' ? query?.q : query?.q?.[0]) || ''

    let risultati = []
    if (q) {
      try {
        const response = await search(locale, q)
        risultati = response.results || []
      } catch (error) {
        console.log(error)
      }
    }

    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate')

    return {
      props: { pagina, query: q, risultati, key: q },
    }
  }
)

export default Search
